import type PaymentItem from "~/types/PaymentItem"
import type Booking from "~/types/Booking"

export default function buildBookingPaymentItems(booking?: Booking | null): PaymentItem[] {
  if (!booking) {
    return [{ description: "", quantity: 1, amountCents: 0 }]
  }

  const items: PaymentItem[] = []

  booking.packs?.forEach((pack) => {
    items.push({
      description: `Package — ${pack.name}`,
      quantity: 1,
      amountCents: pack.priceCents || pack.price?.cents || 0,
    })
  })

  booking.bookingItems?.forEach((bookingItem) => {
    items.push({
      description: bookingItem.name,
      quantity: bookingItem.quantity,
      amountCents: bookingItem.amountCents || 0,
    })

    if ((bookingItem.modifierAmountCents || 0) > 0) {
      items.push({
        description: `${bookingItem.name} — Modifiers`,
        quantity: 1,
        amountCents: bookingItem.modifierAmountCents,
      })
    }
  })

  if ((booking.bookingSurchargeAmountCents || 0) > 0) {
    items.push({
      description: `Booking surcharge (${booking.bookingSurchargeRate || 0}%)`,
      quantity: 1,
      amountCents: booking.bookingSurchargeAmountCents || 0,
    })
  }

  if ((booking.taxAmountCents || 0) > 0) {
    items.push({
      description: `Tax (${booking.taxRate || 0}%)`,
      quantity: 1,
      amountCents: booking.taxAmountCents || 0,
    })
  }

  return items.length > 0 ? items : [{ description: "", quantity: 1, amountCents: 0 }]
}
